<template>
  <w-dialog @close="handleCancel()" title="上传备案项目" show :wallStyle="{zIndex: 2001}" :box-style="{width: '600px', zIndex: 2001}">
    <w-form ref="ruleForm" :model="form" label-width="140px" label-position="left" :rules="rules">
      <w-form-item label="项目编号" prop="projectNumber">
        <w-input size="small" v-model="form.projectNumber" placeholder="请输入项目编号" style="width: 340px;"></w-input>
      </w-form-item>
      <w-form-item label="项目名称" prop="projectName">
        <w-input size="small" v-model="form.projectName" placeholder="请输入项目名称" style="width: 340px;"></w-input>
      </w-form-item>
      <w-form-item prop="projectTag">
        <template slot="label"> 项目标签</template>
        <w-radio-group size="small" v-model="form.projectTag">
          <w-radio label="0" name="projectTag" style="margin-right: 12px;">未中标项目</w-radio>
          <w-radio label="1" name="projectTag" style="margin-right: 12px;">中标项目</w-radio>
          <w-radio label="2" name="projectTag" style="margin-right: 12px;">结算项目</w-radio>
          <w-radio label="3" name="projectTag">评估项目</w-radio>
        </w-radio-group>
      </w-form-item>
      <w-form-item>
        <template slot="label"> 项目权限</template>
        <w-radio-group v-model="form.permissionType" @change="handleChangePermissionType">
          <w-radio label="2" name="permissionType" style="margin-right: 12px;">全员可见</w-radio>
          <w-radio label="1" name="permissionType" style="margin-right: 12px;">部分人可见</w-radio>
          <w-radio label="0" name="permissionType">全员不可见</w-radio>
        </w-radio-group>
        <div class="padding-top-10" v-if="form.permissionType === '1'">
          <w-select @visible-change="handleSelectBlur" class="width-full" size="small" v-model="form.visibleUserList" placeholder="搜索成员姓名" multiple filterable :filter-method="filterMethod">
            <w-option v-for="member in members.filter(item => (item.userName.includes(keyword) || item.account.includes(keyword)))" :key="member.gldUserId" :label="member.userName" :value="member.gldUserId">
              <span class="inline-block ellipsis float_left" style="max-width: 160px;">{{ member.userName }}</span>
              <span class="inline-block ellipsis float_right" style="color: #8492a6; font-size: 13px;max-width: 160px;padding-right: 20px;">{{ member.account }}</span>
            </w-option>
          </w-select>
          <p class="color-default ellipsis">以上成员将可以查看该项目</p>
        </div>
      </w-form-item>
      <w-form-item prop="message">
        <template slot="label"> 项目概况</template>
        <w-input
          type="textarea"
          :rows="3"
          placeholder="请输入项目概况(最多200字)"
          v-model="form.description">
        </w-input>
      </w-form-item>
    </w-form>
    <div class="text-align-right" slot="footer">
      <w-button type="primary" @click.stop.prevent="handleSubmit()">开始上传</w-button>
      <w-button type="minor" @click.stop.prevent="handleCancel()">取消</w-button>
    </div>
  </w-dialog>
</template>

<script>
import spaceService from '@/assets/service/space'
import project from '@/assets/service/r2Project'
export default {
  name: 'UploadProject',
  props: {
    projectName: {
      type: String,
      default: ''
    }
  },
  created () {
    this.form.projectName = this.projectName
    this.getRecordedCode()
  },
  data () {
    const validatePrjName = (rule, value, callback) => {
      if (typeof value === 'string' && value.trim() === '') {
        return callback(new Error('请输入项目名称'))
      } else if (value.match(/[\n"'+%<>|:?*]/) || value.indexOf('/') > -1 || value.indexOf('\\') > -1) {
        return callback(new Error('不能包含特殊字符'))
      } else {
        callback()
      }
    }
    return {
      members: [],
      keyword: '',
      form: {
        projectNumber: '',
        projectName: '',
        projectTag: '',
        permissionType: '0',
        visibleUserList: [],
        description: ''
      },
      rules: {
        projectNumber: [
          {required: true, message: '请输入项目编号', trigger: 'blur'}
        ],
        projectName: [
          {required: true, validator: validatePrjName, trigger: 'blur'}
        ],
        description: [
          {max: 200, message: '长度不能超过200字', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    // 获取项目编号
    getRecordedCode () {
      project.getRecordedCode().then(res => {
        if (res.code === 200 && res.data) {
          this.form.projectNumber = res.data
        }
      })
    },
    // 变更项目权限，获取人员列表
    handleChangePermissionType (value) {
      this.form.visibleUserList = []
      if (value === '1' && this.members.length === 0) {
        this.getUserList()
      }
    },
    // 获取人员列表
    getUserList () {
      spaceService.getUserList().then(res => {
        if (res.code === 200 && Array.isArray(res.data) && res.data.length) {
          this.members = res.data
        } else {
          this.members = []
        }
      }).catch(() => {
        this.members = []
      })
    },
    // 自定义搜索方法
    filterMethod (keyword) {
      this.keyword = keyword.trim()
    },
    // 选择人员下拉框隐藏时
    handleSelectBlur (status) {
      if (!status) {
        // this.keyword = ''
      }
    },
    // 确定上传
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          project.createRecorded(this.form).then(res => {
            console.log(res.data)
            if (res.code === 200) {
              this.$emit('close', true, Object.assign(res.data, {
                permissionType: this.form.permissionType
              }))
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },
    handleCancel () {
      this.$emit('close')
    }
  }
}
</script>
